export const colors = ["#6366F1", "#8B5CF6", "#EC4899", "#EF4444", "#F59E0B", "#10B981", "#3B82F6", "#06B6D4"]

export const colorByName = (name: string) => {
    let hash = 5381
    for (let i = 0; i < name.length; i++) hash = (hash * 33) ^ name.charCodeAt(i)
    const exactHash = hash >>> 0

    return colors[exactHash % colors.length]
}

export enum CSS_VAR_COLORS {
    PRIMARY = "var(--primary)",
    LINK = "var(--link)",
    EDITOR = "var(--editor)",
    DANGER = "$danger"
}

export const operatorStatusColors: Record<string, string> = {
    online: "#219653",
    offline: "#E34646",
    lunch: "#EB8E39",
    training: "#0EABDC",
    invisible: "#A3A3A3"
}
